import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { paths } from '@constants';
import { useAuthStorage } from '@data';
import { useToastsContext } from '@utils';

export const LogoutPage = () => {
  const { showToast } = useToastsContext();

  useEffect(() => {
    useAuthStorage.getState().clearTokens();
    showToast('notifications.loggedOut');
  }, []);

  return <Navigate to={paths.root} replace />;
};
